export const PDD_GOODS_OPT_GET = 'pdd.goods.opt.get';
export const PDD_GOODS_OPT_GET_RESPONSE_KEY = 'goods_opt_get_response';
export const PDD_GOODS_OPT_GET_LIMITERS = [
  {
    limiterLevel: 4,
    timeRange: 10,
    times: 1200,
    callSourceType: 0,
  },
];

/**
 * 接口名称：查询商品标签列表
 * 接口标识：pdd.goods.opt.get
 * 接口使用场景：获得拼多多商品标签列表（非商品类目cat，当前仅开放给多多客使用）
 **/
export interface PddGoodsOptGetRequestInterface {
  /**
   * @description: 值=0时为顶点opt_id,通过树顶级节点获取opt树
   * @type: number
   * @default:
   **/
  parent_opt_id: number;
}

/**
 * 接口名称：查询商品标签列表
 * 接口标识：pdd.goods.opt.get
 * 接口使用场景：获得拼多多商品标签列表（非商品类目cat，当前仅开放给多多客使用）
 **/
export interface PddGoodsOptGetResponseInterface {
  /**
   * @description: 返回response
   * @type: PddGoodsOptGetGoodsOptGetResponseResponseInterface
   * @default:
   *
   **/
  goods_opt_get_response: PddGoodsOptGetGoodsOptGetResponseResponseInterface;
}

/**
 * @description 返回response
 * @default
 * @example
 **/
export interface PddGoodsOptGetGoodsOptGetResponseResponseInterface {
  /**
   * @description: opt列表
   * @type: PddGoodsOptGetGoodsOptGetResponseGoodsOptListResponseInterface[]
   * @default:
   *
   **/
  goods_opt_list: PddGoodsOptGetGoodsOptGetResponseGoodsOptListResponseInterface[];
}

/**
 * @description opt列表
 * @default
 * @example
 **/
export interface PddGoodsOptGetGoodsOptGetResponseGoodsOptListResponseInterface {
  /**
   * @description: 层级，1-一级，2-二级，3-三级，4-四级
   * @type: number
   * @default:
   **/
  level: number;

  /**
   * @description: 商品标签ID
   * @type: string | number
   * @default:
   **/
  opt_id: string | number;

  /**
   * @description: 商品标签名
   * @type: string
   * @default:
   **/
  opt_name: string;

  /**
   * @description: id所属父ID，其中，parent_id=0时为顶级节点
   * @type: string | number
   * @default:
   **/
  parent_opt_id: string | number;
}
